import axios from "axios";
import React, { useState } from "react";
import ReactModal from "react-modal";
import Swal from "sweetalert2";
import ActualizaEstadoOmEvaluador from "../Evaluador/ActualizaOmNoAgrupadaEva";

function CrearGestion(props) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [archivo, setArchivo] = useState(null);
  const [postAccion, setPostAccion] = useState("");
  const [postElemento, setPostElemento] = useState("");
  const [postObservacion, setPostObservacion] = useState("");
  const [loading, setLoading] = useState(false);

  const handleOpenModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const subirArchivo = (e) => {
    setArchivo(e.target.files[0]); // solo uno
  };

  const subirArchivoIndividual = async () => {
    if (!archivo) return;

    const formData = new FormData();
    formData.append("files", archivo);

    try {
      const response = await axios.post(
        `https://suadesarrollo.azurewebsites.net/api/ArchivosOM/${props.idOm}`,
        formData,
      );
      console.log("Archivo subido:", response.data);
      setArchivo(null); // limpiar input
      return true;
    } catch (error) {
      console.error("Error al subir archivo", error);
      Swal.fire("Error", "No se pudo subir el archivo.", "error");
      return false;
    }
  };

  const postData = async (e) => {
    e.preventDefault();
    setLoading(true);

    const auth = {
      username: "BasicAuth@icontec.org",
      password: "yQLzqmR7eZSuAmQZUqhY",
    };

    try {
      // Paso 1: Enviar datos de gestión
      await axios.post(
        "https://suadesarrollo.azurewebsites.net/api/CreaGestionOm",
        {
          omId: props.idOm,
          accionMejora: postAccion,
          elementoVerificacion: postElemento,
          estado: "En revision",
          observacion: postObservacion,
        },
        { auth },
      );

      Swal.fire("Guardado", "Gestión guardada correctamente.", "success");

      // Paso 2: Subir el primer archivo si existe
      if (archivo) {
        const subido = await subirArchivoIndividual();
        if (!subido) return;
      }

      // Paso 3: Preguntar si desea subir otro archivo
      let deseaOtro = true;
      while (deseaOtro) {
        const result = await Swal.fire({
          title: "¿Desea subir otro archivo?",
          showCancelButton: true,
          confirmButtonText: "Sí, subir",
          cancelButtonText: "No, finalizar",
        });

        if (result.isConfirmed) {
          const { value: file } = await Swal.fire({
            title: "Seleccione el archivo",
            input: "file",
            inputAttributes: {
              accept: "*/*",
              "aria-label": "Subir archivo",
            },
            showCancelButton: true,
          });

          if (file) {
            setArchivo(file);
            const subido = await subirArchivoIndividual();
            if (!subido) {
              deseaOtro = false;
            }
          } else {
            deseaOtro = false;
          }
        } else {
          deseaOtro = false;
        }
      }

      // Limpieza de campos
      setPostAccion("");
      setPostElemento("");
      setPostObservacion("");
      setArchivo(null);
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Hubo un problema al guardar la gestión.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <button className="btn btn-primary" onClick={handleOpenModal}>
        Nueva gestión
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Gestión"
        ariaHideApp={false}
      >
        <div className="container">
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">
                Añadir Gestión OM #{props.idOm}
              </h6>
            </div>
            <div className="card-body">
              <ActualizaEstadoOmEvaluador idOm={props.idOm} />
              <form className="user" onSubmit={postData}>
                <div className="form-group">
                  <label>Descripción</label>
                  <textarea
                    className="form-control"
                    value={props.descripcion}
                    disabled
                  />
                </div>

                <div className="form-group mt-3">
                  <label>Acciones a implementar</label>
                  <textarea
                    className="form-control"
                    value={postAccion}
                    onChange={(e) => setPostAccion(e.target.value)}
                    required
                  />
                </div>

                <div className="form-group mt-3">
                  <label>Elementos de verificación</label>
                  <textarea
                    className="form-control"
                    value={postElemento}
                    onChange={(e) => setPostElemento(e.target.value)}
                    required
                  />
                </div>

                <div className="form-group mt-3">
                  <label>Observaciones</label>
                  <textarea
                    className="form-control"
                    value={postObservacion}
                    onChange={(e) => setPostObservacion(e.target.value)}
                    required
                  />
                </div>

                <div className="form-group mt-3">
                  <label>Adjunte un archivo (opcional)</label>
                  <input
                    type="file"
                    className="form-control"
                    onChange={subirArchivo}
                  />
                </div>

                <div className="mt-4 d-flex justify-content-between">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Guardando..." : "Guardar"}
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeModal}
                  >
                    Cerrar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}

export default CrearGestion;
